import { Link } from "react-router-dom";
import { useState } from "react";
import logoBlack from '../../assets/imgs/martin&servera-gruppen_BLACK.png';
import './style.scss';
import FlyoutMenu from "../flyout-menu";

function Header() {
    const [flyoutOpen, setFlyoutOpen] = useState(false);

    return (
        <>
            <div className='header'>
                <FlyoutMenu open={flyoutOpen} closeMenu={() => setFlyoutOpen(false)} />
                <div className="header__logo">
                    <Link to={'/'}>
                        <img
                            src={logoBlack}
                            className="header__logo-image"
                            alt="Martin & Servera Gruppen"
                        />
                    </Link>
                </div>
                <div className="header__menu" onClick={() => setFlyoutOpen(!flyoutOpen)}>
                    <div className="header__menu-icon">
                        <i className={`fa ${flyoutOpen ? 'fa-times' : 'fa-bars'}`}></i>
                    </div>
                    <div className="header__menu-text">Meny</div>
                </div>
            </div>
        </>
    );
}

export default Header;